App.ClientTagsIndexController = Em.Controller.extend
  needs: [ 'client-tags' ]
  clientTagsBinding: 'model'

  env:                 Em.inject.service('environment')
  clientTagsEnabled:   Em.computed.alias('env.features.enableClientTagAutoassign') # СДЕЛАТЬ

  actions:
    openClientTag: (clientTag) ->
      @transitionToRoute 'client-tags.client-tag.edit', clientTag.get('id')